import React, { useCallback, useState } from "react";
import { AppInput, AppNotificationAlert } from "@/layout/AppComponents";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import ReactDOMServer from "react-dom/server";
import { useDispatch, useSelector } from "react-redux";
import Translator from "../../../components/helpers/Translator";
import { axiosPath } from "../../../../routing/helpers/router";
import * as currentPageAction from "../../../../store/actions/currentPageAction";
import AppSubmitButton from "../../../components/form/AppSubmitButton";

export default function CommunicationPipelineLogin(props) {
  const { isRedirect = false, onAuth = () => {} } = props;
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const authReports = useSelector((state) => state.currentPage?.reports) || [];
  const reportTemplate = useSelector(
    (state) => state.currentPage?.moduleData?.reportTemplate
  );
  const [validationSchema] = useState(
    Yup.object().shape({
      hex: Yup.string().required(
        ReactDOMServer.renderToString(<Translator file="module-userManagement" name="required" />)
      ),
    })
  );

  const handleSign = useCallback(
    async (payload) => {
      axios
        .post(
          axiosPath("api_r_user_module_communicationPipeline_user_report_auth"),
          {
            ...payload,
            moduleBridgeHex,
          }
        )
        .then((r) => {
          if (!authReports.includes(payload?.hex)) {
            dispatch(
              currentPageAction.change(
                "reports",
                [...authReports, payload?.hex],
                true
              )
            );
          }
          onAuth({
            routeName:
              r?.data?.type === "report"
                ? "user_module_communicationPipeline_user_report_status"
                : "user_module_communicationPipeline_user_inquiry_communication",
            routeParams:
              r?.data?.type === "report"
                ? {
                    moduleBridgeHex,
                    reportHex: payload?.hex,
                  }
                : {
                    moduleBridgeHex,
                    inquiryHex: payload?.hex,
                  },
          });
        })
        .catch(() => {
          AppNotificationAlert({
            title: ReactDOMServer.renderToString(
              <Translator
                file="module-communicationPipeline"
                name="access-denied"
              />
            ),
            message: ReactDOMServer.renderToString(
              <Translator
                file="module-communicationPipeline"
                name="incorrect-credentials"
              />
            ),
            type: "danger",
            duration: 5000,
            position: "top-right",
          });
        });
    },
    [moduleBridgeHex, authReports]
  );

  return (
    <Formik
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      initialValues={{
        hex: "",
        password: "",
      }}
      onSubmit={handleSign}
    >
      {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <div className="d-flex flex-column h-100">
            <h6 className="mb-1">
              <strong>
                <Translator
                  file="module-communicationPipeline"
                  name={
                    reportTemplate === "haizea"
                      ? "already-communication-query-code"
                      : "already-complaint-query-code"
                  }
                />
                <br />
                <Translator
                  file="module-communicationPipeline"
                  name="enter-data"
                />
              </strong>
            </h6>
            <AppInput
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-communicationPipeline"
                  name={
                    reportTemplate === "haizea"
                      ? "already-communication-query-code"
                      : "already-complaint-query-code"
                  }
                />
              )}
              value={values.hex}
              error={errors?.hex}
              onChange={(v) => setFieldValue("hex", v)}
              isClearable
            />
            <AppInput
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-communicationPipeline"
                  name="password"
                />
              )}
              value={values.password}
              error={errors.password}
              onChange={(v) => setFieldValue("password", v)}
              isClearable
              isPassword
            />
            <AppSubmitButton
              className="btn btn-md btn-primary btn-block mt-2"
              isSubmitting={isSubmitting}
            >
              <Translator file="module-communicationPipeline" name="access" />
            </AppSubmitButton>
          </div>
        </form>
      )}
    </Formik>
  );
}
